"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _dateFns = require("date-fns");

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Avatar = _interopRequireDefault(require("../Avatar/Avatar"));

var _excluded = ["user", "userHoldingImage", "handleOnUserClick", "time", "interactions", "isSmall", "avatarSize", "avatarMargin", "avatarDecoration", "timeMargin", "disableAvatar", "theme"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CursorPointerText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "UserDetails__CursorPointerText",
  componentId: "sc-1vzldr0-0"
})(["cursor:", ";text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"], function (_ref) {
  var isPointer = _ref.isPointer;
  return isPointer ? "pointer" : "default";
});
var CursorPointerAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "UserDetails__CursorPointerAvatar",
  componentId: "sc-1vzldr0-1"
})(["cursor:", ";"], function (_ref2) {
  var isPointer = _ref2.isPointer;
  return isPointer ? "pointer" : "default";
});

var DecorationContainer = _styledComponents["default"].div.withConfig({
  displayName: "UserDetails__DecorationContainer",
  componentId: "sc-1vzldr0-2"
})(["position:absolute;width:0px;overflow:visible;"]);

var DecorationIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "UserDetails__DecorationIcon",
  componentId: "sc-1vzldr0-3"
})(["cursor:", ";position:relative;height:22px;width:22px;transform:translate(20px,-4px) scale(0.8);border-radius:100%;"], function (_ref3) {
  var isPointer = _ref3.isPointer;
  return isPointer ? "pointer" : "default";
});

var AvatarDecoration = function AvatarDecoration(_ref4) {
  var isVisible = _ref4.isVisible,
      isPointer = _ref4.isPointer,
      icon = _ref4.icon,
      bg = _ref4.bg,
      color = _ref4.color,
      onClick = _ref4.onClick;
  if (!isVisible) return null;
  return /*#__PURE__*/_react["default"].createElement(DecorationContainer, null, /*#__PURE__*/_react["default"].createElement(DecorationIcon, {
    name: icon,
    isPointer: isPointer,
    bg: bg,
    color: color,
    onClick: onClick
  }));
};

var toTimeDifference = function toTimeDifference(dateString) {
  return (0, _dateFns.formatDistanceToNow)(new Date(dateString), {
    addSuffix: true
  });
};
/* eslint-disable react/prop-types */


var UserDetails = function UserDetails(_ref5) {
  var _user$picture;

  var user = _ref5.user,
      userHoldingImage = _ref5.userHoldingImage,
      handleOnUserClick = _ref5.handleOnUserClick,
      time = _ref5.time,
      interactions = _ref5.interactions,
      isSmall = _ref5.isSmall,
      _ref5$avatarSize = _ref5.avatarSize,
      avatarSize = _ref5$avatarSize === void 0 ? 40 : _ref5$avatarSize,
      _ref5$avatarMargin = _ref5.avatarMargin,
      avatarMargin = _ref5$avatarMargin === void 0 ? 3 : _ref5$avatarMargin,
      avatarDecoration = _ref5.avatarDecoration,
      _ref5$timeMargin = _ref5.timeMargin,
      timeMargin = _ref5$timeMargin === void 0 ? 2 : _ref5$timeMargin,
      _ref5$disableAvatar = _ref5.disableAvatar,
      disableAvatar = _ref5$disableAvatar === void 0 ? false : _ref5$disableAvatar,
      theme = _ref5.theme,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref5, _excluded);

  var handleUserClick = _react["default"].useCallback(function () {
    return handleOnUserClick && handleOnUserClick();
  }, [handleOnUserClick]);

  var isPointer = !!handleOnUserClick;

  var calculateMargin = function calculateMargin(margin) {
    return theme.space[margin] || margin;
  };

  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    mb: isSmall ? 1 : 3,
    width: "100%"
  }, props), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    alignItems: "flex-start",
    width: "100%"
  }, !disableAvatar && /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    width: 40,
    mr: avatarMargin
  }, /*#__PURE__*/_react["default"].createElement(CursorPointerAvatar, {
    onClick: handleUserClick,
    isPointer: isPointer,
    picture: (user == null ? void 0 : (_user$picture = user.picture) == null ? void 0 : _user$picture.small) || userHoldingImage,
    size: avatarSize
  }), !!avatarDecoration && /*#__PURE__*/_react["default"].createElement(AvatarDecoration, {
    isPointer: isPointer,
    onClick: handleUserClick,
    isVisible: avatarDecoration.isVisible,
    bg: avatarDecoration.bg,
    color: avatarDecoration.color,
    icon: avatarDecoration.icon
  })), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    flexDirection: "column",
    width: disableAvatar ? "100%" : "calc(100% - 40px - " + calculateMargin(avatarMargin) + "px)",
    justifyContent: "center"
  }, user ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(CursorPointerText, {
    fontWeight: "500",
    fontSize: isSmall ? 3 : 4,
    width: "100%",
    isPointer: isPointer,
    onClick: handleUserClick
  }, user.firstName + " " + user.lastName), (user == null ? void 0 : user.jobTitle) && /*#__PURE__*/_react["default"].createElement(CursorPointerText, {
    color: "dark.2",
    mt: 1,
    fontSize: isSmall ? 2 : 3,
    isPointer: isPointer,
    width: "100%",
    onClick: handleUserClick
  }, user == null ? void 0 : user.jobTitle), user.companyName && /*#__PURE__*/_react["default"].createElement(CursorPointerText, {
    color: "dark.2",
    mt: 1,
    fontSize: isSmall ? 2 : 3,
    isPointer: isPointer,
    width: "100%",
    onClick: handleUserClick
  }, user.companyName)) : /*#__PURE__*/_react["default"].createElement(CursorPointerText, {
    width: "100%",
    fontWeight: "500"
  }, "Posted Anonymously"), time && /*#__PURE__*/_react["default"].createElement(CursorPointerText, {
    color: "dark.2",
    fontSize: isSmall ? 1 : 2,
    mt: timeMargin,
    width: "auto"
  }, toTimeDifference(time)))), interactions && interactions());
};

var _default = (0, _styledComponents.withTheme)(UserDetails);

exports["default"] = _default;